import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import { getWhatsAppChatUrl } from '../../constants/contact';
import './WhatsAppFloat.css';

/**
 * Fixed bottom-right button on every page — opens WhatsApp chat.
 */
const WhatsAppFloat = () => (
  <a
    href={getWhatsAppChatUrl()}
    className="whatsapp-float"
    target="_blank"
    rel="noopener noreferrer"
    title="Chat on WhatsApp"
    aria-label="Chat with Luxistt on WhatsApp"
  >
    <FaWhatsapp className="whatsapp-float-icon" aria-hidden />
    <span className="whatsapp-float-label">Chat</span>
  </a>
);

export default WhatsAppFloat;
